import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { dadosOrganizacao, logo } from '../../config';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';

import { Container, ContainerWhite } from './styles';

import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Vimeo from '../../components/Vimeo';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Politica: React.FC = () => {
  return (
    <>
      <ContainerWhite id="termos">
        <div className="p50 p600" style={{ textAlign: 'justify' }}>
          <h2>  POLÍTICA DE REEMBOLSO DE INGRESSOS</h2>
          <br />

          <p>
            Solicitações de reembolso respeitarão o cronograma descrito abaixo:

            <table className='tableRef'>
              <tbody>
                <tr>
                  <td>até 30 dias antes do evento, a inscrição pode ser cancelada com a obtenção de 80% do valor pago. Além da retenção de 20%, o valor relativo à taxa de operação da opção de pagamento escolhida não será devolvida.</td>
                </tr>
                <tr>
                  <td>até 8 dias antes do evento, a inscrição pode ser cancelada com a obtenção de 50% do valor pago. Além da retenção de 50%, o valor relativo à taxa de operação da opção de pagamento escolhida não será devolvida.</td>
                </tr>
                <tr>
                  <td>7 dias antes do evento ou menos, não ocorrerá devolução de valores de inscrição, com exceções que serão avaliadas pela comissão organizadora, mediante apresentação de atestado médico ou equivalente.</td>
                </tr>
              </tbody>
            </table>
            <br />

            Trocas de titularidade da inscrição podem ser realizadas a qualquer momento até 7 dias antes do início do evento. No limite de 2 trocas. Nesta movimentação, não incidem custos, porém não é realizada substituição de documento fiscal.
            <br /><br />
            Prazo de devolução: até dia 10 do mês subsequente ao mês de repasse do valor pela empresa responsável pelas inscrições. O crédito será sempre em favor do responsável financeiro pela inscrição; não serão realizados créditos em favor de terceiros.
          </p>

        </div>
      </ContainerWhite>
    </>
  );
};
export default Politica;
